export default __webpack_public_path__ + "locales/bg/Translations.json?hash=acfca78808dbf5ea2d9c97b2339c6b19";